import { render, staticRenderFns } from "./ReadOnlyBanner.vue?vue&type=template&id=1da19465"
import script from "./ReadOnlyBanner.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports